var map = {
	"./Ancient_Fruit.png": 123,
	"./Ancient_Fruit_Gold.png": 124,
	"./Apple.png": 125,
	"./Apricot.png": 126,
	"./Aquamarine.png": 127,
	"./Autumns_Bounty.png": 128,
	"./Bait.png": 129,
	"./Bat_Wing.png": 130,
	"./Bee_House.png": 131,
	"./Blackberry.png": 132,
	"./Blueberry.png": 133,
	"./Bream.png": 134,
	"./Bullhead.png": 135,
	"./Bundle_Green.png": 136,
	"./Bundle_Orange.png": 137,
	"./Bundle_Purchase.png": 138,
	"./Bundle_Teal.png": 139,
	"./Bundle_Yellow.png": 140,
	"./Cactus_Fruit.png": 141,
	"./Carp.png": 142,
	"./Cauliflower.png": 143,
	"./Cave_Carrot.png": 144,
	"./Caviar.png": 145,
	"./Charcoal_Kiln.png": 146,
	"./Cheese.png": 147,
	"./Cheese_Press.png": 148,
	"./Cherry.png": 149,
	"./Chocolate_Cake.png": 150,
	"./Chub.png": 151,
	"./Clam.png": 152,
	"./Cloth.png": 153,
	"./Cockle.png": 154,
	"./Coconut.png": 155,
	"./Common_Mushroom.png": 156,
	"./Copper_Bar.png": 157,
	"./Corn.png": 158,
	"./Corn_Gold.png": 159,
	"./Crab.png": 160,
	"./Crab_Pot.png": 161,
	"./Crayfish.png": 162,
	"./Crocus.png": 163,
	"./Crystal_Fruit.png": 164,
	"./Crystalarium.png": 165,
	"./Daffodil.png": 166,
	"./Dandelion.png": 167,
	"./Dinosaur_Mayonnaise.png": 168,
	"./Dish_o_The_Sea.png": 169,
	"./Dressed_Spinner.png": 170,
	"./Duck_Egg.png": 171,
	"./Duck_Feather.png": 172,
	"./Earth_Crystal.png": 173,
	"./Eel.png": 174,
	"./Eggplant.png": 175,
	"./Fall_Seeds.png": 176,
	"./Fiddlehead_Fern.png": 177,
	"./Fire_Quartz.png": 178,
	"./Fried_Egg.png": 179,
	"./Frozen_Geode.png": 180,
	"./Frozen_Tear.png": 181,
	"./Furnace.png": 182,
	"./Ghostfish.png": 183,
	"./Goat_Cheese.png": 184,
	"./Gold.png": 185,
	"./Gold_Bar.png": 186,
	"./Gold_Quality_Icon.png": 187,
	"./Grape.png": 188,
	"./Green_Bean.png": 189,
	"./Hardwood.png": 190,
	"./Hay.png": 191,
	"./Hazelnut.png": 192,
	"./Heater.png": 193,
	"./Honey.png": 194,
	"./Hot_Pepper.png": 195,
	"./Iron_Bar.png": 196,
	"./Jelly.png": 197,
	"./Keg.png": 198,
	"./Large_Brown_Egg.png": 199,
	"./Large_Egg.png": 200,
	"./Large_Goat_Milk.png": 201,
	"./Large_Milk.png": 202,
	"./Largemouth_Bass.png": 203,
	"./Leek.png": 204,
	"./Lightning_Rod.png": 205,
	"./Lobster.png": 206,
	"./Maki_Roll.png": 207,
	"./Maple_Syrup.png": 208,
	"./Melon.png": 209,
	"./Melon_Gold.png": 210,
	"./Morel.png": 211,
	"./Mussel.png": 212,
	"./Nautilus_Shell.png": 213,
	"./Oak_Resin.png": 214,
	"./Omni_Geode.png": 215,
	"./Orange.png": 216,
	"./Oyster.png": 217,
	"./Parsnip.png": 218,
	"./Parsnip_Gold.png": 219,
	"./Peach.png": 220,
	"./Periwinkle.png": 221,
	"./Pine_Tar.png": 222,
	"./Pink_Cake.png": 223,
	"./Pomegranate.png": 224,
	"./Poppy.png": 225,
	"./Potato.png": 226,
	"./Preserves_Jar.png": 227,
	"./Prismatic_Shard.png": 228,
	"./Pufferfish.png": 229,
	"./Pumpkin.png": 230,
	"./Pumpkin_Gold.png": 231,
	"./Purple_Mushroom.png": 232,
	"./Quality_Fertilizer.png": 233,
	"./Quality_Sprinkler.png": 234,
	"./Quartz.png": 235,
	"./Rabbits_Foot.png": 236,
	"./Recycling_Machine.png": 237,
	"./Red_Cabbage.png": 238,
	"./Red_Mushroom.png": 239,
	"./Red_Snapper.png": 240,
	"./Sandfish.png": 241,
	"./Sardine.png": 242,
	"./Sea_Urchin.png": 243,
	"./Seed_Maker.png": 244,
	"./Shrimp.png": 245,
	"./Silver_Quality_Icon.png": 246,
	"./Slime.png": 247,
	"./Small_Glow_Ring.png": 248,
	"./Small_Magnet_Ring.png": 249,
	"./Snail.png": 250,
	"./Snow_Yam.png": 251,
	"./Solar_Essence.png": 252,
	"./Speed-Gro.png": 253,
	"./Spice_Berry.png": 254,
	"./Spring_Seeds.png": 255,
	"./Stone.png": 256,
	"./Sturgeon.png": 257,
	"./Summer_Seeds.png": 258,
	"./Sunflower.png": 259,
	"./Sweet_Pea.png": 260,
	"./Tilapia.png": 261,
	"./Tomato.png": 262,
	"./Truffle.png": 263,
	"./Truffle_Oil.png": 264,
	"./Tuna.png": 265,
	"./Void_Essence.png": 266,
	"./Void_Salmon.png": 267,
	"./Void_Salmon_Gold.png": 268,
	"./Walleye.png": 269,
	"./Warp_Totem_Beach.png": 270,
	"./Wheat.png": 271,
	"./Wild_Horseradish.png": 272,
	"./Wild_Plum.png": 273,
	"./Wine.png": 274,
	"./Wine_Silver.png": 275,
	"./Winter_Root.png": 276,
	"./Winter_Seeds.png": 277,
	"./Wood.png": 278,
	"./Woodskip.png": 279,
	"./Wool.png": 280,
	"./Yam.png": 281,
	"./catfish.png": 282,
	"./shad.png": 283,
	"./stardewbackground.png": 284,
	"./sunfish.png": 285,
	"./tiger_trout.png": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;